module.exports = __webpack_public_path__ + "img/bannerImg.4252913b.png";